import { Team } from './../team';
import { UserNodeBuilder } from './user-node.builder';

export class TeamBuilder {
    static build(siteId, teamVO, isPrincipal): Team {
        const team = new Team();
        team.id = teamVO.id;
        team.site = siteId;
        team.libelle = teamVO.libelle;
        team.users = [];
        team.tlPeriods = teamVO.tlPeriods;
        team.isPrincipal = isPrincipal;
        team.teamAssignment = teamVO.teamAssignment;
        teamVO.users.forEach(userNodeVO => {
            team.users.push(UserNodeBuilder.build(siteId, team.id, userNodeVO, teamVO.tlPeriods));
        });
        return team;
    }
}


// team.tlPeriods = teamVO.tlPeriods.map(period => {
//     if(moment(period.end).isAfter(moment().format(DATE_DEFAULT_FORMAT))) period.end = moment().format(DATE_DEFAULT_FORMAT);
//     return period;
// })



// WEBPACK FOOTER //
// ./src/app/model/builder/team.builder.ts